export const PROFILE_HOST = process.env.PROFILE_HOST



/** WEBPACK FOOTER **
 ** ./src/constants/env.js
 **/